<template>
  <q-page class="faq q-mb-48">
    <MainHeader :title="content.h1" />
    <section class="container q-px-16">
      <div class="row">
        <div class="col-xs-12">
          <article>
            <h2>{{ content.what_is_gettransfer.header }}</h2>
            <p>{{ content.what_is_gettransfer.text }}</p>
            <p>{{ $t('legal.disclaimer') }}</p>
          </article>
          <article>
            <h2>{{ content.how_to_book.header }}</h2>
            <ol>
              <li
                v-for="item in content.how_to_book.items"
                :key="item"
              >
                {{ item }}
              </li>
            </ol>
          </article>
          <article>
            <h2>{{ content.questions.header }}</h2>
            <div
              v-for="item in content.questions.items"
              :key="item.question"
              class="q-mb-48"
            >
              <h3 class="text-bold fs-18">{{ item.question }}</h3>
              <p v-html="item.answer" />
            </div>
          </article>
        </div>
      </div>
    </section>
  </q-page>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import MainHeader from 'components/MainHeader';

const { tm } = useI18n();

const content = computed(() => tm('pages.faq'));
</script>

<style lang="scss" scoped>
p, li {
  color: #666;
}
</style>
